import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';

import Loader from '@components/common/Loader';
import useStore from '@hooks/useStore';

export interface IPopupWindowHandlerProps {
  acsURL: string;
  cReq: string;
}

const PopupWindowHandler: FC<IPopupWindowHandlerProps> = ({ acsURL, cReq }) => {
  const { fiserv } = useStore();

  useEffect(() => {
    if (acsURL && cReq) {
      fiserv.updateField('acsURL', acsURL);
      fiserv.updateField('cReq', cReq);
      const form = fiserv.accessControlServer();
      document.body.appendChild(form);
      // submit ACS
      form.submit();
    }
  }, []);

  return <Loader />;
};

export default observer(PopupWindowHandler);
